/** Языки портала. Добавить язык = добавить сюда и положить два JSON-словаря. */
export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ru", label: "Русский" },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]["code"];

export const DEFAULT_LANGUAGE: LanguageCode = "en";
/** Язык, на который откатываемся, если ключа нет в выбранном. */
export const FALLBACK_LANGUAGE: LanguageCode = "en";

export const LANGUAGE_STORAGE_KEY = "phygc-portal-language";
